import { createRouter } from '@tanstack/react-router';
import type { ParseKeys } from 'i18next';

import { FullscreenLoading } from './components/layout/fullscreen-loading';
import { NotFound } from './components/layout/not-found';
import { RouteError } from './components/layout/route-error';
import { routeTree } from './routeTree.gen';

export const router = createRouter({
	routeTree,
	/**
	 *  {@link https://tanstack.com/router/v1/docs/framework/react/guide/router-context#how-about-using-react-contexthooks}
	 */
	context: { queryClient: undefined!, msal: undefined! },
	// TODO: remove msal when the login functionality is ready
	defaultPreload: 'intent',
	/**
	 * Since we're using React Query, we don't want loader calls to ever be stale
	 * This will ensure that the loader is always called when the route is preloaded or visited
	 */
	defaultPreloadStaleTime: 0,
	defaultErrorComponent: RouteError,
	defaultPendingComponent: FullscreenLoading,
	defaultNotFoundComponent: NotFound,
});

declare module '@tanstack/react-router' {
	interface Register {
		router: typeof router;
	}

	interface StaticDataRouteOption {
		/** Translation key of the module name shown in the browser tab title */
		titleKey?: ParseKeys;
	}
}
